import * as React from "react";
const SvgCreditcard = () => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.746 5.202a.793.793 0 0 0-.794.794v1.429h18.096V5.996a.793.793 0 0 0-.794-.794zm17.302 3.175H2.952v2.222h18.096zm0 3.175H2.952v5.873c0 .438.355.793.794.793h16.508a.793.793 0 0 0 .794-.793zM2 5.996c0-.965.781-1.746 1.746-1.746h16.508c.964 0 1.746.781 1.746 1.746v11.429c0 .964-.782 1.746-1.746 1.746H3.746A1.746 1.746 0 0 1 2 17.425zm2.54 8.889c0-.263.213-.476.476-.476H9.46a.476.476 0 0 1 0 .952H5.016a.476.476 0 0 1-.476-.476m12.698 0c0-.263.213-.476.476-.476h1.27a.476.476 0 1 1 0 .952h-1.27a.476.476 0 0 1-.476-.476",
    clipRule: "evenodd"
  }
));
export default SvgCreditcard;
